import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import swal from 'sweetalert2';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { UserDetailService } from '@app/feature/main/roles-shared/services/user-detail.service';
import { MasterDataService } from '@app/shared/services/master-data.service';
import { LikedinService } from '@app/likedin.service';
import { environment } from '@env/environment';
import { Constants } from '@app/shared/constants/app.constants';
import { TechBuyerOrganization } from '@app/feature/main/tech-buyer/shared/models/tech-buyer-organization-model';
import { GeographicResponsibilityService } from '@app/shared/services/geographic-responsibility.service';
import { TechBuyerService } from '@app/feature/main/tech-buyer/shared/services/tech-buyer.service';
import { AccountService } from '@app/feature/external/account/shared/services/account.service';
import * as _ from "lodash";
import { TechVendorOrganizationModal } from '@app/feature/main/tech-vendor/shared/models/tech-vendor-organization-model';
import { TechVendorService } from '@app/feature/main/tech-vendor/shared/services/tech-vendor.service';
import { TechVendorCompleteMyProfile } from '@app/feature/main/tech-vendor/shared/models/tech-vendor-profile-model';
import { TechBuyerCompleteMyProfile } from '@app/feature/main/tech-buyer/shared/models/tech-buyer-profile-model';

declare var $: any;

@Component({
  selector: 'app-complete-profile',
  templateUrl: './complete-profile.component.html',
  styleUrls: ['./complete-profile.component.css']
})
export class CompleteProfileComponent implements OnInit, OnDestroy {

  profileCompletionStatus = 'incomplete';
  imageChangedEvent: any = "";
  croppedImage: any = "";
  toast = swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 5000
  });

  private subscription: Subscription;
  userProfile: any;
  userDetailsObject: any;
  pmpActive = false;

  userId = "";
  userEmail = "";

  techBuyerOrganization = new TechBuyerOrganization();
  techVendorOrganization = new TechVendorOrganizationModal();
  techVendorProfile = new TechVendorCompleteMyProfile();
  techBuyerProfile = new TechBuyerCompleteMyProfile();

  labelName = '';
  selectedGeoCountryList =[]
  countryDialCode = 65;
  geographies = [];
  selectedRegions = [];
  countries = [];
  itBudgetData = [];
  revenuesData = [];
  employeeSizesData = [];
  industryData = [];
  lineOfBusinesses = [];
  jobTitles = [];

  firstName: string;
  lastName: string;
  mobileNumber: string;
  selectedCountry: any;

  techBuyerOrganizationForm: FormGroup;
  techVendorOrganizationForm: FormGroup;
  companyDetailsSubmitted = true;
  organizations = [];
  organizationNames = [];
  organization: any = {};
  geographicData = [];
  org = "";
  map = new Map();
  geographicresponsibily: any = {};
  completeAllOrganizationList: any = [];
  selectedCountryList: any = [];
  geoTitle: string;
  modifiedTechBuyerOrganization = new Object();
  modifiedTechVendorOrganization = new Object();
  companyDetailsUpdated: any;
  userRole: any;
  accessToken: any;

  settings = {
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "custom-select form-control-default form-control-default-select",
    enableSearchFilter: true,
    allowcustomvalue: true,
    labelKey: "countryName"
  };
  mobileNotValidation: any;
  geoResposiblityList: any;

  constructor(
    private rolesSharedService: RolesSharedService,
    private userDetailService: UserDetailService,
    private formBuilder: FormBuilder,
    private masterDataService: MasterDataService,
    private accountService: AccountService,
    private techBuyerService: TechBuyerService,
    private techVendorService: TechVendorService,
    private router: Router,
    private geoResponsiblityService: GeographicResponsibilityService
  ) {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userId = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      ).userId;
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
    }
    this.userRole = this.userDetailsObject.roles[0].code;
    this.accessToken = this.userDetailsObject.accessToken;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async ngOnInit() {
    this.getOrganizationsList();
    this.getGeoGraphicsList();
    this.getGeoResponsibilty();
    this.createForm();
    this.initializeModal();
    await this.getUserDetails();
  }
  onItemSelect(item: any) {
    console.log(item);
    console.log(this.techVendorOrganizationForm.controls['regionsCovered']);
  }

  validateMobileNumber() {
    console.log(this.mobileNumber);
  }

  telInputObject(event) {
    //
  }

  hasError(error) {
    this.mobileNotValidation = error;
  }

  getNumber(event) {
    this.mobileNotValidation = null;
    this.mobileNumber = event;
  }

  onCountryChange(event) {
    this.countryDialCode = event.dialCode;
  }

  printCountry() {
    this.techBuyerOrganization.countryId = this.techVendorOrganization.countryId;
  }

  imageUploadClick(fileUploadElement: any) {
    let el: HTMLElement = fileUploadElement as HTMLElement;
    el.click();
  }

  imageChangedInElement(event: any): void {
    this.imageChangedEvent = event;
    $("#imageUploadModal").modal("show");
  }

  imageCropped(image: string) {
    this.croppedImage = image;
  }

  imageLoaded() {
    console.log('a');
  }

  loadImageFailed() {
    console.log('a');
  }

  saveCroppedImage() {
    this.rolesSharedService.imageUploadInS3(this.croppedImage).subscribe(
      (response: any) => {
        this.rolesSharedService
          .s3ImageLinkToProfile(this.userId, response)
          .subscribe(
            (finalResponse: any) => {
              this.toast({
                type: "success",
                text: "Profile picture updated successfully"
              });
              this.userDetailService.onChange(finalResponse.profileUrl);
              this.getUserDetails();
              $("#imageUploadModal").modal("hide");
            },
            (error: any) => {
              this.toast({
                type: "info",
                text: error.error.error.message
              });
            }
          );
      },
      (error: any) => {
        this.toast({
          type: "info",
          text: error.error.error.message
        });
      }
    );
  }

  getUserDetails() {
    this.masterDataService.getUserDetails(this.userId).subscribe(
      (response: any) => {
        this.userDetailsObject = response;
        this.patchFields();
      },
      error => { }
    );
  }

  initializeModal() {
    this.getCountries();
    this.getIndustries();
    this.getRevenues();
    this.getItBudgets();
    this.getEmployeeSizes();
    this.getJobTitles();
    this.getLineOfBusinesses();
    this.getGeography();
  }

  getCountries() {
    this.masterDataService.getCountries().subscribe(
      (response: any) => {
        this.countries = response;
      },
      error => { }
    );
  }

  getIndustries() {
    this.masterDataService.getIndustries().subscribe(
      (response: any) => {
        this.industryData = response;
      },
      error => { }
    );
  }
  getEmployeeSizes() {
    this.masterDataService.getEmployeeSizes().subscribe(
      (response: any) => {
        this.employeeSizesData = response.data;
      },
      error => { }
    );
  }

  getRevenues() {
    this.masterDataService.getRevenues().subscribe(
      (response: any) => {
        this.revenuesData = response.data;
      },
      error => { }
    );
  }

  getItBudgets() {
    this.masterDataService.getItBudgets().subscribe(
      (response: any) => {
        this.itBudgetData = response.data;
      },
      error => { }
    );
  }

  getJobTitles() {
    if (this.jobTitles.length < 1) {
      this.masterDataService.getJobTitles().subscribe(
        (response: any) => {
          this.jobTitles = response;
        },
        error => { }
      );
    }
  }

  getLineOfBusinesses() {
    if (this.lineOfBusinesses.length < 1) {
      this.masterDataService.getLineOfBusinesses().subscribe(
        (response: any) => {
          this.lineOfBusinesses = response;
        },
        error => { }
      );
    }
  }

  getGeography() {
    if (this.geographies.length < 1) {
      this.masterDataService.getGeographies().subscribe(
        (response: any) => {
          this.geographies = response;
        },
        error => { }
      );
    }
  }

  // check black listed domain list
  checkBlacklistedDomain() {
    if (!this.userEmail) {
      return;
    }
    this.accountService
      .checkBlockListDomain(this.userEmail, "tech_buyer")
      .subscribe(
        (response: any) => {
          this.prefilOrganizationName(response);
        },
        error => { }
      );
  }

  prefilOrganizationName(response) {
    if (response.statusCode === 200 && response.companyData.length > 0) {
      const companyList = _.map(response.companyData, "name");
      const companyName = companyList[0];
      this.org = companyName;

      this.map.clear();
      for (let i = 0; i < this.organizations.length; i++) {
        this.map.set(this.organizations[i].name, this.organizations[i].id);
      }
    }
  }

  // organisation auto complete fixes
  getOrganizationsList() {
    this.accountService.getOrganizationsList().subscribe(
      (response: any) => {
        this.completeAllOrganizationList = _.map(response, "name");
        this.organizationNames = _.map(response, "name");
      },
      error => { }
    );
  }

  createForm() {

    this.techBuyerOrganizationForm = this.formBuilder.group({
      industry: [""],
      employeeSize: [""],
      globalRevenue: [""],
      itBudget: [""],
      lob: [""],
      jobTitle: [""],
      geographicResponsibility: [""],
      geoCountry: [],
      labelName: [""]
    });
    this.techVendorOrganizationForm = this.formBuilder.group({
      employeeSize: [""],
      globalRevenue: [""],
      lob: [""],
      jobTitle: [""],
      geographicResponsibility: [""],
      geoCountry: [],
      labelName: [""]
    });


    $("#company-details").on("hidden.bs.modal", () => {
      this.techBuyerOrganizationForm.reset();
    });
  }


  /***** Where all the submission happens *****/
  submitUserDetails() {
    let formattedMobileNumber;
    let geographicalResponsibility;
    if (this.mobileNumber) {
      formattedMobileNumber = this.mobileNumber.split(this.countryDialCode.toString())[1];
    } 

    if(this.techVendorProfile.geographicResponsibilityId === 'custom' || this.techBuyerProfile.geographicResponsibilityId === 'custom') {
        let selectedCountryIds = [];
        
        for (let index = 0; index < this.selectedGeoCountryList.length; index++) {
          selectedCountryIds.push(this.selectedGeoCountryList[index].id)
        }
        
        geographicalResponsibility = {
          title: this.labelName,
          type: 'custom',
          countryIds: selectedCountryIds
        }
    }

    /** Tech Buyer */
    if (this.userRole === "tech_buyer") {

      if (this.map.has(this.org)) {
        this.modifiedTechBuyerOrganization = Object.assign(
          { organizationId: this.map.get(this.org) },
          this.techBuyerOrganization
        );
      } else {
        this.modifiedTechBuyerOrganization = Object.assign(
          { organizationName: this.org },
          this.techBuyerOrganization
        );
      }

      this.companyDetailsSubmitted = false;
      this.techBuyerService
        .updateBuyerCompanyDetails(
          this.userId,
          this.modifiedTechBuyerOrganization
        )
        .subscribe(
          response => {
            window.scroll(0, 0);
            this.techBuyerOrganizationForm.markAsPristine();
            this.companyDetailsSubmitted = true;
          },
          error => {
            this.companyDetailsSubmitted = true;
            swal("Error!", "Your details are incomplete, please fill all the details!", "error");
          }
        );

      this.techBuyerProfile.jobTitleId = this.techBuyerOrganization.jobTitleId;
      this.techBuyerProfile.lineOfBusinessId = this.techBuyerOrganization.lineOfBusinessId;
      this.techBuyerProfile.firstName = this.firstName;
      this.techBuyerProfile.lastName = this.lastName;
      if(formattedMobileNumber) {
        this.techBuyerProfile.contactNumbers = [{userId: this.userId, contactNumber:'+' + this.countryDialCode + ' ' +formattedMobileNumber}];
      }
      this.techBuyerProfile.geographicalResponsibility = geographicalResponsibility;
      const userDetails = this.techBuyerProfile;
      this.techBuyerService
        .updateBuyerDetails(this.userId, userDetails)
        .subscribe(
          (response: any) => {
            
            this.accountService.getuserDetails(this.userId, this.accessToken).subscribe(
              (newResponse: any) => {
                window.sessionStorage.setItem("techBuyerOrganization", JSON.stringify(newResponse.techbuyerOrganization));
                swal({
                  title: "Success!",
                  text: "Company Information Updated!",
                  type: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Home",
                  confirmButtonClass: "btn adjust-swal-button",
                  buttonsStyling: false
                }).then(result => {
                  this.router.navigate(["/"]);
                });
              },
              error => {
              }
            );
          },
          error => {
          }
        );
    } 
    
    /** Tech Vendor */
    else if (this.userRole === "tech_vendor") {
              
      if (this.map.has(this.org)) { 
        this.modifiedTechVendorOrganization = Object.assign(
          { organizationId: this.map.get(this.org) },
          this.techVendorOrganization
        );
      } else {
        this.modifiedTechVendorOrganization = Object.assign(
          { organizationName: this.org },
          this.techVendorOrganization
        );
      }

      this.companyDetailsSubmitted = false;
      this.techVendorService
        .updateVendorCompanyDetails(
          this.userId,
          this.modifiedTechVendorOrganization
        )
        .subscribe(
          response => {
            window.scroll(0, 0);
            this.techVendorOrganizationForm.markAsPristine();
            this.companyDetailsSubmitted = true;
          },
          error => {
            this.companyDetailsSubmitted = true;
            swal("Info", "Your details are incomplete, please fill all the details and try again!", "info");
          }
        );

      this.techVendorProfile.firstName = this.firstName;
      this.techVendorProfile.lastName = this.lastName;
      if(formattedMobileNumber) {
        this.techBuyerProfile.contactNumbers = [{userId: this.userId, contactNumber:'+' + this.countryDialCode + ' ' +formattedMobileNumber}];
      }
      this.techVendorProfile.geographicalResponsibility = geographicalResponsibility;
      const userDetails = this.techVendorProfile;
      
      this.techVendorService
        .updateVendorDetails(this.userId, userDetails)
        .subscribe(
          (response: any) => {
            this.accountService.getuserDetails(this.userId, this.accessToken).subscribe(
              (newResponse: any) => {
                window.sessionStorage.setItem("techvendorOrganization", JSON.stringify(newResponse.techvendorOrganization));
                swal({
                  title: "Success!",
                  text: "Company Information Updated!",
                  type: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "Home",
                  confirmButtonClass: "btn adjust-swal-button",
                  buttonsStyling: false
                }).then(result => {
                  this.router.navigate(["/"]);
                });
              },
              error => {
              }
            );        
          },
          error => {
            swal("Error", error.error.message, "info");
          }
        );
        
    }
  }
  /***** End Submission *****/


  /***** Where all the patching happens *****/
  async patchFields() {
    this.firstName = this.userDetailsObject.firstName;
    this.lastName = this.userDetailsObject.lastName;
    if (this.userDetailsObject.contactNumbers.length > 0) {
      this.mobileNumber = this.userDetailsObject.contactNumbers[0].contactNumber;
      this.mobileNumber = this.mobileNumber.split(' ')[1];
    }
    if (this.userDetailsObject.organization) {
      this.org = this.userDetailsObject.organization.name;
    }

    if (this.userRole == 'tech_buyer') {
      // this.labelName = ;
      if (this.userDetailsObject.geographicResponsibilityId) {
        this.techBuyerProfile.geographicResponsibilityId = this.userDetailsObject.geographicResponsibilityId;
      }
      if (this.userDetailsObject.jobTitleId) {
        this.techBuyerOrganization.jobTitleId = this.userDetailsObject.jobTitleId;
      }
      if (this.userDetailsObject.lineOfBusinessId) {
        this.techBuyerOrganization.lineOfBusinessId = this.userDetailsObject.lineOfBusinessId;
      }
      if (this.userDetailsObject.techbuyerOrganization) {
        this.techVendorOrganization.countryId = this.userDetailsObject.techbuyerOrganization.countryId;
        this.techBuyerOrganization.industryId = this.userDetailsObject.techbuyerOrganization.industryId;
        this.techBuyerOrganization.employeeSizeId = this.userDetailsObject.techbuyerOrganization.employeeSizeId;
        this.techBuyerOrganization.revenueId = this.userDetailsObject.techbuyerOrganization.revenueId;
        this.techBuyerOrganization.itBudgetId = this.userDetailsObject.techbuyerOrganization.itBudgetId;
      }


    } else if (this.userRole == 'tech_vendor') {

      // this.labelName = ;
      if (this.userDetailsObject.geographicResponsibilityId) {
        this.techVendorProfile.geographicResponsibilityId = this.userDetailsObject.geographicResponsibilityId;
      }
      if (this.userDetailsObject.jobTitleId) {
        this.techVendorProfile.jobTitleId = this.userDetailsObject.jobTitleId;
      }
      if (this.userDetailsObject.lineOfBusinessId) {
        this.techVendorProfile.lineOfBusinessId = this.userDetailsObject.lineOfBusinessId;
      }

      if (this.userDetailsObject.techvendorOrganization) {
        this.techVendorOrganization.countryId = this.userDetailsObject.techvendorOrganization.countryId;
        this.techVendorOrganization.employeeSizeId = this.userDetailsObject.techvendorOrganization.employeeSizeId;
        this.techVendorOrganization.revenueId = this.userDetailsObject.techvendorOrganization.revenueId;
        this.techVendorOrganization.countryId = this.userDetailsObject.techvendorOrganization.countryId;
      }

    }

  }
  /***** End Patching *****/

  redirectToHomePage() {
   
    const redirectResearchBuyerURL = localStorage.getItem('RESEARCH_BUYER_URL');
    const isFromHome = localStorage.getItem('isFromHome');
    const redirectResearchURL = localStorage.getItem('RESEARCH_URL');
    const redirectReportURL = localStorage.getItem('REPORT_URL');
    
  

    if (this.userRole == "tech_buyer" && isFromHome === "true") {
      if(redirectReportURL !== null) {
        this.router.navigateByUrl("tech-buyer" + redirectReportURL);
       } else {
        this.router.navigateByUrl("tech-buyer/research-snapshot" + redirectResearchBuyerURL);
       }
      
    }else if (this.userRole === "tech_vendor" && isFromHome === "true") {
       if(redirectReportURL !== null) {
        this.router.navigateByUrl("tech-vendor" + redirectReportURL);
       } else {
        this.router.navigateByUrl("tech-vendor" + redirectResearchURL);
       }

   } else if(this.userRole === "ecosystm_staff" && isFromHome === "true") {
        this.router.navigateByUrl("ecosystm_staff" + redirectReportURL);
   }
   else if(this.userRole === "tech_analyst" && isFromHome === "true") {
        this.router.navigateByUrl("tech-analyst/reports" + redirectReportURL);
   }
  
    else{
      window.sessionStorage.setItem('firstTimeSet', 'set');
      this.router.navigate(["/"]);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  //georesposibilty code
  getGeoGraphicsList() {
    this.geoResponsiblityService.getGeographicList().subscribe(
      (resp: any) => {
        this.geographicData = resp.data;
      },
      error => { }
    );
  }
  getCountryListForSelectedGeoResp(id) {
    if (id !== "custom" && id && id !== "undefined") {
      this.geoResponsiblityService.getCountryListBygeoId(id).subscribe(
        (resp: any) => {
          const a_map = resp.countries.reduce(
            (acc, value) =>
              Object.assign({}, acc, { [value.countryId]: value }),
            {}
          );
          const uniques = this.countries.filter(o => !!a_map[o.id]);
          this.selectedCountryList = uniques.map(obj => {
            obj.itemName = obj.countryName;
            return obj;
          });
          this.geoTitle = this.geographicData.find(
            data => data.id === id
          ).title;
        },
        err => { }
      );
    } else {
      this.selectedCountryList = [];
      this.geoTitle = null;
    }
  }
  showCountryList(value) {
    if (value) {
      this.getCountryListForSelectedGeoResp(value);
    }
  }

  schangeDropdownState(className, selectClassName) {
    document.querySelectorAll(className).forEach(el => {
      if (
        this.organization.geographic &&
        this.organization.geographic !== "custom"
      ) {
        el.classList.remove("enable-country");
        el.classList.add("disabled-country");
      } else {
        el.classList.remove("disabled-country");
        el.classList.add("enable-country");
      }
    });
    document.querySelectorAll(selectClassName).forEach(el => {
      if (
        this.organization.geographic &&
        this.organization.geographic !== "custom"
      ) {
        el.classList.add("hide-close-btn");
      } else {
        el.classList.remove("hide-close-btn");
      }
    });
  }

  updateGeoResponse(id) {
    const data = { title: this.geoTitle };
    this.geoResponsiblityService
      .updateGeoresponse(id, data)
      .subscribe(resp => {}, error => {});
  }

  getGeoResponsibilty() {
    this.geoResponsiblityService.getGeographicList().subscribe(
      (resp: any) => {
        this.geoResposiblityList = resp.data;
      },
      error => {}
    );
  }
  schangeGeoDropdownState(className,selectClassName) {
    document.querySelectorAll(className).forEach(el => {
      if (
        this.techVendorProfile.geographicResponsibilityId &&
        this.techVendorProfile.geographicResponsibilityId !== "custom"
      ) {
        el.classList.remove("enable-country");
        el.classList.add("disabled-country");
      } else {
        el.classList.remove("disabled-country");
        el.classList.add("enable-country");
      }
    });
    document.querySelectorAll(selectClassName).forEach(el => {
      if (
        this.techVendorProfile.geographicResponsibilityId &&
        this.techVendorProfile.geographicResponsibilityId === "custom"
      ) {
        el.classList.remove("is-disabled");
      } else {
        el.classList.add("is-disabled");
      }
    });
    // $('.lazyContainer').scrollTop(0);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/complete-profile/complete-profile.component.ts